import * as types from "./mutation-types";

export default {
  [types.SET_QUEUESLIST](state, payload) {
    state.queuesList = payload;
  },
};
